export var validationMixin = {
  filters: {
    formatQuantity (value) {
        return (value)?(String(value).replace('.', ',')):value;
    }
  },
  data: () => ({
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    usernameRules: [
      v => !!v || 'Username is required',
      v => v &&v.trim()!=''
    ],
    nameRules: [
      v => !!v || 'Name is required',
      v => v &&v.trim()!=''
    ],
    passwordRules: [
      v => !!v || 'Password is required'
    ],
    privacyPolicyRules: [
      v => !!v || 'You must accept the Privacy Policy'
    ],
    termsRules: [
      v => !!v || 'You must accept the Terms and conditions'
    ],

    notEmptyRules: [
      v => !!v || 'Inserat Name is required'
      //v => v.length <= 8 || 'Name must be less than 8 characters', + :counter="8"
    ],
    notZeroNumberRules: [
      v => !!v || 'Number have to be greater than Zero',
      v => v >0 
    ],
    notGreatherTreeRule: [
      v => !!v || 'Number have to be greater than Zero',
      v => v >= 1 || 'Number greather 1',
      v => v <=3 || 'Du darfst aus rechtlichen Gründen maximal 3 Stellplätze anbieten'
    ],
    priceRules: [
      v => !!v || 'Number have to be greater than Zero',
      v => v >=0.01
    ],
    mobileRule:[
      v => !!v || 'Phone is required',
      v => /(\(?([\d \-)–+/(]+){0,}\)?([ .\-–/]?)([\d]+))/g.test(v) || 'Phone must be valid',
    ],
    
  }),

  computed: {
    // we need this in computed because this.password is not available in data
    confirmPasswordRules () {
      return [
        v => !!v || 'Password confirmation is required',
        v => v === this.password || 'Passwords must match'
      ]
    }
  }

}
